/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PatchPartnerV1Dto = {
  /**
   * The current version of the contract.
   */
  version: number;
  /**
   * The unique identifier as hexadecimal value of the partner group linked to this partner. As 8-4-4-4-12 format.
   */
  partnerGroupId?: string;
  /**
   * The name of the partner.
   */
  name?: string;
  /**
   * The email address of the partner.
   */
  eMail?: string | null;
  /**
   * The phone number of the partner.
   */
  phone?: string | null;
  /**
   * The language of correspondence with the partner.
   */
  languageOfCorrespondence?: PatchPartnerV1Dto.languageOfCorrespondence | null;
};
export namespace PatchPartnerV1Dto {
  /**
   * The language of correspondence with the partner.
   */
  export enum languageOfCorrespondence {
    GERMAN = 'german',
    ENGLISH = 'english',
  }
}
